import React, { useState, useEffect, useCallback } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import DataTable from "../../../components/DataTable";
import * as HTTPServices from "../../../api/HTTPServices";
import ChartOverview from "./overview";
import Filter from "../../../components/DataTable/Filter";

function DrTransactions() {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(0);
  const [tableDate, setTableData] = useState("");
  const [paidTableDate, setPaidTableDate] = useState();
  const [fixPaidTableDate, setFixPaidTableDate] = useState();

  const [month, setMounth] = React.useState("");
  const [fixedTransactionData, setFixedTransactionData] = useState("");
  const [totalTransactionPrice, setTotalTransactionPrice] = useState(0);
  const [totalPaidData, setTTotalPaidData] = useState(0);

  let counter = 0;

  const createData = useCallback(
    (key, name, date, time, status, price, message) => {
      return { id: counter, key, name, date, time, status, price, message };
    },
    [counter]
  );

  // function createData(key, name, date, time, status, price, message) {
  //   counter += 1;
  //   return { id: counter, key, name, date, time, status, price, message };
  // }
  useEffect(() => {
    const RequestService = HTTPServices.getMethod(
      "doctor_transaction",
      "",
      "true"
    );

    const RequestService2 = HTTPServices.getMethod(
      "doctor_paid_transaction",
      "",
      "true"
    );

    RequestService.then(function (response) {
      if (response) {
        let data = [];
        response.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.status,
              item.price,
              item.message
            )
          );
          return data;
        });
        setTableData(data);
        setFixedTransactionData(data);
      }
    }).catch(function (error) {});

    RequestService2.then(function (res) {
      if (res) {
        let data = [];
        res.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.status,
              item.price,
              item.message
            )
          );
          return data;
        });
        setPaidTableDate(data);
        setFixPaidTableDate(data);
      }
    });
  }, [createData]);

  useEffect(() => {
    setTimeout(() => {
      let totalTransactionPrice = 0;
      let TotalPaidPrice = 0;
      if (tableDate) {
        tableDate.map((item) => {
          item.price = item.price.replace(/\D/g, "");
          totalTransactionPrice = totalTransactionPrice + parseInt(item.price);
          return totalTransactionPrice;
        });
        setTotalTransactionPrice(totalTransactionPrice);
      }
      if (paidTableDate) {
        paidTableDate.map((item) => {
          item.price = item.price.replace(/\D/g, "");
          TotalPaidPrice = TotalPaidPrice + parseInt(item.price);
          return TotalPaidPrice;
        });
        setTTotalPaidData(TotalPaidPrice);
      }
    }, 500);
  });
  const columns = [
    { id: 1, field: "name", headerName: "name of payer", width: 180 },
    { id: 2, field: "date", headerName: "date", width: 180 },
    { id: 3, field: "time", headerName: "time", width: 180 },
    { id: 4, field: "status", headerName: "status", width: 180 },
    { id: 5, field: "price", headerName: "price", width: 180 },
    { id: 6, field: "message", headerName: "description", width: 250 },
  ];

  function a11yProps(index) {
    return {
      id: `scrollable-prevent-tab-${index}`,
      "aria-controls": `scrollable-prevent-tabpanel-${index}`,
    };
  }
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <p>{children}</p>
          </Box>
        )}
      </div>
    );
  }

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleChangeMonth = (e) => {
    setMounth(e.target.value);
    let filter = [];
    fixedTransactionData.map((data) => {
      const slug = data.date.substring(data.date.indexOf("/") + 1);
      const objectMonth = slug.substring(0, 2);
      if (objectMonth === e.target.value) {
        filter.push(data);
      }
      return objectMonth;
    });
    setTimeout(() => {
      setTableData(filter);
    }, 200);
  };

  const getLastweek = () => {
    const Requestlastweek = HTTPServices.getMethod(
      "doctor_transaction_lastweek",
      "",
      "true"
    );
    Requestlastweek.then(function (res) {
      if (res) {
        let data = [];
        res.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.status,
              item.price,
              item.message
            )
          );
          return data;
        });
        setTimeout(() => {
          setTableData(data);
        }, 100);
      }
    });
  };
  const getLastmonth = () => {
    const Requestlastweek = HTTPServices.getMethod(
      "doctor_transaction_lastmonth",
      "",
      "true"
    );
    Requestlastweek.then(function (res) {
      if (res) {
        let data = [];
        res.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.status,
              item.price,
              item.message
            )
          );
          return data;
        });
        setTimeout(() => {
          setTableData(data);
        }, 100);
      }
    });
  };
  const getCurrentmonth = () => {
    const Requestlastweek = HTTPServices.getMethod(
      "doctor_transaction_currentmonth",
      "",
      "true"
    );
    Requestlastweek.then(function (res) {
      if (res) {
        let data = [];
        res.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.status,
              item.price,
              item.message
            )
          );
          return data;
        });
        setTimeout(() => {
          setTableData(data);
        }, 100);
      }
    });
  };

  const handleChangeMonthPaid = (e) => {
    setMounth(e.target.value);
    let filter = [];
    fixPaidTableDate.map((data) => {
      const slug = data.date.substring(data.date.indexOf("/") + 1);
      const objectMonth = slug.substring(0, 2);
      if (objectMonth === e.target.value) {
        filter.push(data);
      }
      return objectMonth;
    });
    setTimeout(() => {
      setPaidTableDate(filter);
    }, 200);
  };

  const getLastweekPaid = () => {
    const Requestlastweek = HTTPServices.getMethod(
      "doctor_paid_transaction_lastweek",
      "",
      "true"
    );
    Requestlastweek.then(function (res) {
      if (res) {
        let data = [];
        res.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.status,
              item.price,
              item.message
            )
          );
          return data;
        });
        setTimeout(() => {
          setPaidTableDate(data);
        }, 100);
      }
    });
  };
  const getLastmonthPaid = () => {
    const Requestlastweek = HTTPServices.getMethod(
      "doctor_paid_transaction_lastmonth",
      "",
      "true"
    );
    Requestlastweek.then(function (res) {
      if (res) {
        let data = [];
        res.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.status,
              item.price,
              item.message
            )
          );
          return data;
        });
        setTimeout(() => {
          setPaidTableDate(data);
        }, 100);
      }
    });
  };
  const getCurrentmonthPaid = () => {
    const Requestlastweek = HTTPServices.getMethod(
      "doctor_paid_transaction_currentmonth",
      "",
      "true"
    );
    Requestlastweek.then(function (res) {
      if (res) {
        let data = [];
        res.map(function (item) {
          data.push(
            createData(
              item.key,
              item.user_name,
              item.date,
              item.time,
              item.status,
              item.price,
              item.message
            )
          );
          return data;
        });
        setTimeout(() => {
          setPaidTableDate(data);
        }, 100);
      }
    });
  };
  return (
    <div style={{ width: "100%" }}>
      <Tabs
        value={activeTab}
        textColor="primary"
        onChange={handleChangeTab}
        style={{
          borderTop: "1px solid",
          borderColor: "#e2dfdf",
        }}
        centered
        TabIndicatorProps={{ style: { background: "#f7b500" } }}
        className="step-two"
      >
        <Tab
          label={t("pages.protectedPages.transactions.overView")}
          style={activeTab === 0 ? styles.activeTabStyle : styles.tab}
          fullWidth
          {...a11yProps(0)}
        />
        <Tab
          label={t("pages.protectedPages.transactions.transactions")}
          style={activeTab === 1 ? styles.activeTabStyle : styles.tab}
          fullWidth
          {...a11yProps(1)}
        />
        <Tab
          label={t("pages.protectedPages.transactions.pays")}
          style={activeTab === 2 ? styles.activeTabStyle : styles.tab}
          fullWidth
          {...a11yProps(2)}
        />
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <ChartOverview />
      </TabPanel>
      <TabPanel value={activeTab} index={1} style={{ overflow: "auto" }}>
        <div style={{ overflow: "auto" }}>
          <Filter
            handleChange={handleChangeMonth}
            month={month}
            removeFilters={() => {
              setTableData(fixedTransactionData);
            }}
            getLastweek={getLastweek}
            getLastmonth={getLastmonth}
            getCurrentmonth={getCurrentmonth}
          >
            {mounth &&
              mounth.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </Filter>
          <DataTable rows={tableDate} columns={columns} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              marginTop: 5,
              marginBottom: 80,
              padding: 10,
              backgroundColor: "#dcc4ff",
              border: "2px solid #7747bf",
              borderRadius: 10,
              width: "fit-content",
            }}
          >
            <p style={{ fontSize: 14 }}>
              {t("pages.protectedPages.transactions.total")}
              {totalTransactionPrice}
            </p>
          </div>
        </div>
      </TabPanel>
      <TabPanel value={activeTab} index={2} style={{ overflow: "auto" }}>
        <div style={{ overflow: "auto" }}>
          <Filter
            handleChange={handleChangeMonthPaid}
            month={month}
            removeFilters={() => {
              setPaidTableDate(fixPaidTableDate);
            }}
            getLastweek={getLastweekPaid}
            getLastmonth={getLastmonthPaid}
            getCurrentmonth={getCurrentmonthPaid}
          >
            {mounth &&
              mounth.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </Filter>
          <DataTable rows={paidTableDate} columns={columns} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              marginTop: 5,
              marginBottom: 80,
              padding: 10,
              backgroundColor: "#dcc4ff",
              border: "2px solid #7747bf",
              borderRadius: 10,
              width: "fit-content",
            }}
          >
            <p style={{ fontSize: 14 }}>
              {t("pages.protectedPages.transactions.total")} {totalPaidData}
            </p>
          </div>
        </div>
      </TabPanel>
    </div>
  );
}

export default DrTransactions;

const styles = {
  tab: {
    minWidth: 100,
    fontSize: 14,
  },
  activeTabStyle: {
    minWidth: 100,
    fontSize: 14,

    backgroundColor: "#fef8e6",
    color: "#f7b500",
  },
};

const mounth = [
  {
    value: "01",
    label: "month 1",
  },
  {
    value: "02",
    label: "month 2",
  },
  {
    value: "03",
    label: "month 3",
  },
  {
    value: "04",
    label: "month 4",
  },
  {
    value: "05",
    label: "month 5",
  },
  {
    value: "06",
    label: "month 6",
  },
  {
    value: "07",
    label: "month 7",
  },
  {
    value: "08",
    label: "month 8",
  },
  {
    value: "09",
    label: "month 9",
  },
  {
    value: "10",
    label: "month 10",
  },
  {
    value: "11",
    label: "month 11",
  },
  {
    value: "12",
    label: "month 12",
  },
];
